import { gql } from '@apollo/client';

export const FEATURE_FLAGS = gql`
  query FeatureFlags($organizationId: ID) {
    featureFlags(organizationId: $organizationId) {
      flags {
        key
        value
      }
    }
  }
`;

export type FeatureFlagsQueryResult = {
  featureFlags: {
    flags: Array<{
      key: string;
      value: string;
    }>;
  };
};

export type FeatureFlagsQueryVariables = {
  organizationId?: string | null;
};
